<div class="dropzone"
  [class.dragover]="dragover"
  fileDragDrop
  (filesChangeEmiter)="onFileChange($event)"
  (dragOver)="dragOver()"
  (dragLeave)="dragLeave()"
  #dropzone>
  <div class="dropzone-content">
    <mat-icon class="symbol" svgIcon="cloud_upload" (click)="addFile()"></mat-icon>
    <span [innerHTML]="dropzoneTextTranslation"></span>
  </div>
  <input type="file" #fileInputHidden (change)="onFileChangeClick($event)" style="display: none;" />
</div>
